"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionFields = exports.OrderStatusFields = void 0;
var OrderStatusFields;
(function (OrderStatusFields) {
    OrderStatusFields["OrderState"] = "orderState";
    OrderStatusFields["PaymentState"] = "paymentState";
})(OrderStatusFields = exports.OrderStatusFields || (exports.OrderStatusFields = {}));
var CommissionFields;
(function (CommissionFields) {
    CommissionFields["Sum"] = "sum";
    CommissionFields["PurchasedClips"] = "purchasedClips";
})(CommissionFields = exports.CommissionFields || (exports.CommissionFields = {}));
//# sourceMappingURL=retail-info.js.map